<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="d-flex flex-row justify-content-between pb-2">
    <div *ngIf="!isWaiter" class="d-flex flex-row">
      <input (change)="onFileSelected($event)" class="open-file" style="display: none;" type="file" id="openFile"
        #openFile name="openFile" accept="image/png, image/jpg, image/jpeg" />
      <img class="profile_picture"
        (click)="openAddImage()"
        [src]="!editProfileModel.profilePictureUrl ? imagePath :editProfileModel.profilePictureUrl "
        alt="profile-picture">
      <div class="picture-edit mt-2">
        <p class="hide_mobile mt-3 primary_medium_text_16">
          {{ 'EDIT_PROFILE.UPLOAD_IMAGE_MESSAGE' | translate }}
          <label *ngIf="pictureIsWrongFormat">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
              pTooltip="{{'EDIT_PROFILE.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
        </p>
        <p class=" show_mobile mt-3 primary_medium_text_16">
          {{ 'EDIT_PROFILE.UPLOAD_IMAGE_MESSAGE_MOBILE' | translate }}
          <label *ngIf="pictureIsWrongFormat">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
              pTooltip="{{'EDIT_PROFILE.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
        </p>
      </div>
    </div>
  </div>
  <div class="display_block_mbl d-flex flex-row justify-content-between pb-2">
    <div class="w-50 w_100_mbl">
      <label class="lbl_pos_field">{{'EDIT_PROFILE.NAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Name']!=null"
          class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['Name']|translate}}"
          tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="editProfileModel.firstName">
    </div>
    <div class="w-50 w_100_mbl">
      <label class="lbl_pos_field">{{'EDIT_PROFILE.SURNAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Surname']!=null"
          class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
          pTooltip="{{errorModel['Surname']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="editProfileModel.lastName">
    </div>
  </div>
  <div class="display_block_mbl d-flex flex-row justify-content-between pb-2">
    <div class="w-50 w_100_mbl">
      <label class="lbl_pos_field">{{'EDIT_PROFILE.COMPANY_NAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['CompanyName']!=null"
          class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
          pTooltip="{{errorModel['CompanyName']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" disabled [(ngModel)]="editProfileModel.companyName">
    </div>
    <div class="w-50 w_100_mbl">
      <label class="lbl_pos_field">{{'EDIT_PROFILE.ADDRESS' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Address']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Address']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="editProfileModel.address">
    </div>
  </div>
  <div class="display_block_mbl d-flex flex-row justify-content-between pb-2">
    <div class="w-50 w_100_mbl">
      <label class="lbl_pos_field">{{'EDIT_PROFILE.EMAIL' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Email']!=null"
          class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['Email']|translate}}"
          tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="editProfileModel.email" disabled>
    </div>
    <div class="w-50 w_100_mbl">
      <label class="lbl_pos_field">{{'EDIT_PROFILE.PHONE' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Phone']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['Phone']|translate}}"
           tooltipPosition="top"></i>
      </label>
      <input type="number" class="primary_input_field" [(ngModel)]="editProfileModel.phone">
    </div>
  </div>
  <div *ngIf="!isWaiter" class="display_block_mbl d-flex flex-row justify-content-end">
    <button class="change-password-btn" (click)="changePassword()">{{ 'INFO.CHANGE_PASSWORD' | translate}}</button>
  </div>
  <div class="d-flex flex-row justify-content-between pb-2">
    <button *ngIf="!isWaiter" class="btn_login w-100" (click)="updateProfile(editProfileModel)">{{ 'SAVE' | translate}}</button>
    <button *ngIf="isWaiter" class="btn_login w-100" (click)="updateWaiterProfile(editProfileModel)">{{ 'SAVE' | translate}}</button>
  </div>
</div>
<p-toast position="bottom-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>
